import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { Base } from "ui/Scripts/source/framework/base";

export interface ITaskTypeNew {
    systemTaskTypes: ITaskEditTypeItem[];
    companyTaskTypes: ITaskEditTypeItem[];
}

export class TaskTypeNew implements ITaskTypeNew {
    systemTaskTypes: TaskEditTypeItem[];
    companyTaskTypes: TaskEditTypeItem[];

    constructor();
    constructor(obj: ITaskTypeNew);
    constructor(obj?: any) {
        this.systemTaskTypes = Base.getTypedArray(obj?.systemTaskTypes, TaskEditTypeItem);
        this.companyTaskTypes = Base.getTypedArray(obj?.companyTaskTypes, TaskEditTypeItem);
    }
}